import { ControlLayout } from '../Enums/ControlLayout'
import { DropdownListItem } from './DropdownListItem'
import { CustomValidation } from './CustomValidation'
import { Attribute } from './Attribute'
import { ForceDirection } from '../Enums/ForceDirection'
import { Subject } from 'rxjs'

export class DropdownOptions{
     /**
 * Represent Name Of Form Control
 */
Name:string
/**
*   Represent classes to DropdownList that allow us to select the DatePicker by jquery or javascript 
*/

ExtraClasses:string

/**  Represent value of the label*/
LabelValue:string
 /**  Represent Key of the label*/
 LabelKey:string
/**  Represent value of the labelDescription show under DropdownList*/
LabelDescription:string
/** Represent value of the Placeholder of DropdownList */
Placeholder:string
/**To set  DataSource  to DropdownList */
DataSource:DropdownListItem[]
/**To set  SelectedItem  to DropdownList */
SelectedItems:any
/**
* Display "*" beside the label 
* if ForceAsterisk=true and IsRequired=True his display "*" ,
* if if ForceAsterisk=false and IsRequired=false this remove "*",
*if ForceAsterisk=false and IsRequired=True this display "*" , 
*/ 
ShowAsterisk: boolean
/** Ability to set  DropdownList required */
IsRequired: boolean
/** Disable Bootstrap DropdownList */
DisableBootstrapSelect:boolean=false;
/** Ability to display or hide the label of DropdownList */
HideLabel:  boolean
/** Sets an attribute disable="disabled"  */
IsDisabled: boolean
/**  to set type of view  if DropdownList is Vertical or Horizontal */
ViewType:ControlLayout=ControlLayout.Vertical

/**  to set  DropdownList in SingleMode Or MultibleMode */
SingleSelection:boolean
/**  to set  Number Of selected Element That will Show In The Box */
ItemsShowLimit:number
/**  to Show Search Filter Box*/
AllowSearchFilter:boolean
/**  To Set Custom Validation*/
CustomValidation: CustomValidation[]=[]
/**  to set  Limit Of selected Element For DropdownList */
LimitSelection?:number
/** Set List of Custom Attribute to DropdownList  */
AttributeList:Attribute[]
/** Set css classes to  DropdownList  */
Classes: string;
/** Allow  Show Checkbox */
ShowCheckbox?: boolean;
/** Allow Check ALL Items */
EnableCheckAll?: boolean;
/** Set key for item in  DropdownList  */
ItemTempletkey:string="key"
/** Set value for item in  DropdownList  */
ItemTempletvalue:string="value"
ForceDirection: ForceDirection=ForceDirection.English

}